import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { OmitStrict } from "../utils";
import { WorkspaceRole } from "./workspace-role";

export const WorkspaceInvitation = z.object({
  id: z.string(),
  email: z.string().email(),
  createdAt: z.coerce.date(),
  resentAt: z.coerce.date().nullish(),
  role: z.nativeEnum(WorkspaceRole),
  workspaceId: z.string(),
  invitedBy: z.string(),
});

export type WorkspaceInvitation = z.infer<typeof WorkspaceInvitation>;

export type CreateWorkspaceInvitation = DbCreateInputOmit<WorkspaceInvitation>;
export type UpdateWorkspaceInvitation = OmitStrict<
  DbUpdate<WorkspaceInvitation>,
  "email" | "invitedBy" | "workspaceId"
>;
